import { CDError } from 'utils/error';
import { Auth } from 'aws-amplify';

export type LoginVariables = {
  username: string;
  password: string;
};

export type Login = {
  accessToken: string;
  refreshToken: string;
  externalTokens: {
    chat: {
      token: string;
    };
  };
};

const loginRequest = async ({ username, password }: LoginVariables) => {
  try {
    const user = await Auth.signIn(username, password);

    return {
      accessToken: user.getSignInUserSession().getIdToken().getJwtToken(),
      refreshToken: user.getSignInUserSession().getRefreshToken().token,
      externalTokens: { chat: { token: '' } },
    };
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};

export default loginRequest;
